import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchTime:null
  },
  getters: {
    getSearchTime:state=>state.searchTime
  },
  mutations: {
    setSearchTime(state,data){
      state.searchTime = data
    }
  },
  actions: {
  },
  modules: {
  }
})
